/**
 * Boolean/Yes-No input component for questions
 * Uses options from question if available, otherwise defaults to Yes/No
 */
export const BooleanInput = ({ questionId, question, value, onChange, disabled, saving }) => {
  // Determine options: use question.options if available, otherwise default to Yes/No
  let options = ['Yes', 'No']; // Default options
  
  if (question?.options) {
    try {
      const parsedOptions = typeof question.options === 'string' 
        ? JSON.parse(question.options) 
        : question.options;
      if (Array.isArray(parsedOptions) && parsedOptions.length > 0) {
        options = parsedOptions;
      }
    } catch (e) {
      // If parsing fails, use default Yes/No
      console.warn('Failed to parse question options, using default Yes/No:', e);
    }
  }
  
  return (
    <div className="space-y-3">
      {options.map(option => (
        <label key={option} className={`flex items-center ${disabled ? 'cursor-default' : 'cursor-pointer'}`}>
          <input
            type="radio"
            name={`question-${questionId}`}
            value={option}
            checked={value === option}
            onChange={(e) => onChange(questionId, 'answer', e.target.value)}
            className="mr-3 text-emerald-700 dark:text-emerald-400"
            disabled={disabled || saving}
          />
          <span className="text-gray-700 dark:text-gray-300">{option}</span>
        </label>
      ))}
    </div>
  );
};

